<template>
  <div>
    <Banner :classType="5" />
    <Menu />

    <div class="wrap storeBox wow animate__slideInUp" ref="stock">
      <el-row :gutter="50" class="storeRow">
        <el-col :xs="24" :sm="24" :md="12"
          ><h2>{{ stockInfo.Name }} {{ stockInfo.Code }}</h2></el-col
        >
        <el-col :xs="24" :sm="24" :md="12"
          >截至
          {{
            this.$moment(stockInfo.UpdateDateTime).format("YYYY-MM-DD HH:mm:ss")
          }}
          北京时间*报价有十五分钟或以上延迟。资料来源：东方财富网</el-col
        >
      </el-row>
      <el-row :gutter="50" class="storeRow">
        <el-col :xs="24" :sm="24" :md="12" class="storeOne"
          ><span class="redWords bigWords">{{ stockInfo.SharePrice }}</span>
          <span class="storeRB">RMB</span>
          <a :href="stockInfo.KLine" target="_blank">查看K线图 →</a></el-col
        >
        <el-col :xs="24" :sm="24" :md="12">
          <el-row type="flex" class="storeInfo">
            <el-col :span="6"
              >最高<span class="redWords">{{ stockInfo.Highest }}</span></el-col
            >
            <el-col :span="6"
              >最低<span class="redWords">{{ stockInfo.Lowest }}</span></el-col
            >
            <el-col :span="6"
              >成交量（{{ stockInfo.TradingVolumeUnit }}）<span
                class="redWords"
                >{{ stockInfo.TradingVolume }}</span
              ></el-col
            >
            <el-col :span="6"
              >成交额（{{ stockInfo.TurnoverUnit }}）<span class="redWords">{{
                stockInfo.Turnover
              }}</span></el-col
            >
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div class="pageTitle wow animate__slideInUp" ref="note" id="note">
      <h2>公司公告</h2>
      <p>ANNOUNCEMENT</p>
    </div>

    <ul class="myTabs2 wow animate__slideInUp">
      <li
        :key="idx"
        :class="{ current: newsOn == idx }"
        v-for="(item, idx) in newsNav"
        @click="newsTabFn(idx)"
      >
        {{ item }}
      </li>
    </ul>
    <div class="wrap wow animate__slideInUp">
      <NewsList v-if="newsOn == 0" :newsList="newsList" />
      <NewsList v-else actionTxt="资料下载" :newsList="newsList2" down="down" />

      <div class="pageBox" v-if="showPage">
        <Pagination @pageChange="getNewsList" :PagingInfo="PagingInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
// import Banner from "./Banner.vue";
import Banner from "@/views/components/Banner";
import NewsList from "@/views/components/NewsList";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";

export default {
  data() {
    return {
      activeName: "first",
      newsNav: ["临时公告", "定期报告"],
      newsOn: 0,
      type: this.$route.query.type || "",
      newsList: [],
      newsList2: [],
      PagingInfo: {},
      newsType: 9,
      stockInfo: {},
      pageCur:1,
      showPage:false
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getData(page, type) {
      this.$api
        .fileList({
          Type: 4,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { FileInfos, PagingInfo } = res.Value;
          this.newsList2 = FileInfos;
          this.PagingInfo = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    newsTabFn(idx) {
      if (this.newsOn != idx) {
        this.newsOn = idx;
        if (idx == 0) {
          this.newsType = 9;
          this.$api
            .newsList({
              Type: this.newsType,
              CurrentPage: 1,
              ItemsPerPage: 8,
            })
            .then((res) => {
              const { NewsItems, PagingInfo } = res.Value;
              this.newsList = NewsItems;
              this.PagingInfo = PagingInfo;
            });
        } else {
          // this.newsType = 10;
          this.getData(1);
        }
      }
    },
    handleScroll() {
      let note = this.$refs.note.offsetTop;
       let meshine =  navigator.userAgent
      var element = meshine.indexOf('Weixin')==-1 ? document.documentElement : document.body;
      element.scrollTop = note - 60;
    },
    getNewsList(page, type) {
      this.$api
        .newsList({
          Type: this.newsType,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { NewsItems, PagingInfo } = res.Value;
          this.newsList = NewsItems;
          this.PagingInfo = PagingInfo;
          this.showPage = true
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        if (this.type == "note") {
          this.handleScroll();
        }
      }
    );
  },
  beforeRouteEnter(to, from,next) {
    let fromURL = from.name
    next((vm)=>{
      if(fromURL == 'newsContent')
      vm.pageCur =sessionStorage.getItem('currentPage')
    })
  },
  mounted() {
    this.type = this.$route.params.type;
    if (this.type == "note") {
      this.handleScroll();
    }
    this.getNewsList(this.pageCur, "first");
    this.$api.stock().then((res) => {
      const { Value } = res;
      this.stockInfo = Value;
    });

    /* this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        console.log("toParams", toParams);
        this.type = toParams.type;
        if (this.type == "note") {
          this.handleScroll();
        }
      }
    ); */
  },
  components: {
    NewsList,
    Menu,
    Banner,
    Pagination,
  },
};
</script>

<style lang="scss">
.storeBox {
  border-top: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  margin-top: 50px !important;
  padding-bottom: 30px;
  h2 {
    font-size: 24px;
    font-weight: 400;
  }
  .redWords {
    color: #c6322d;
  }
  .storeRow {
    padding: 30px 0 0;
  }
  .bigWords {
    font-size: 35px;
  }
  .storeRB {
    padding: 0 30px 0 10px;
  }
  .storeInfo {
    .redWords {
      font-size: 20px;
      display: block;
    }
  }
}
</style>